import api from '@/services/api/whatsNew'
import { useState } from 'react'

const useWhatsNew = () => {

	const [error, setError] = useState()
	const [visible,setVisbile] = useState(false)

	async function fetch() {
		const [err, response] = await api.getWhatsNew();

		if(err){
			if (err.message === "Error in getting the Featues updates") {
				// No features set yet
				return [err, null];
			}
			setError('Error in getting Features')
		}

		// No WhatsNew row: admin may answer 400, a 200 null body (handleResponse then
		// returns the raw axios response) or Go's {data: null}. None of these is a feature.
		const hasFeatures = Boolean(response?.id) && Array.isArray(response?.features) && response.features.length > 0;
		if (!hasFeatures) {
			return [err, null];
		}

		setVisbile(true);
		return [err, response];
	}

	async function accept(payload) {

		const [err, response] = await api.updateUserWhatsNewId(payload);
		if (err) {
			return setError('Error in updating new Feature status');
		}
		return [err, response]
	}



	return {
		error,
		fetch,
		accept,
		visible,
		setVisbile
	}

}

export default useWhatsNew
